(function() { window.GUID_ec287eb5_a710_4057_abb4_5f72b8e71fa4 = { getGuid: function() { return "ec287eb5-a710-4057-abb4-5f72b8e71fa4"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var Graph;
        (function (Graph) {
            var Models;
            (function (Models) {
                let GraphTypes;
                (function (GraphTypes) {
                    GraphTypes[GraphTypes["line"] = 0] = "line";
                    GraphTypes[GraphTypes["area"] = 1] = "area";
                    GraphTypes[GraphTypes["bar"] = 2] = "bar";
                    GraphTypes[GraphTypes["radar"] = 3] = "radar";
                    GraphTypes[GraphTypes["pie"] = 4] = "pie";
                    GraphTypes[GraphTypes["doughnut"] = 5] = "doughnut";
                    GraphTypes[GraphTypes["polarArea"] = 6] = "polarArea";
                    GraphTypes[GraphTypes["bubble"] = 7] = "bubble";
                    GraphTypes[GraphTypes["scatter"] = 8] = "scatter";
                })(GraphTypes = Models.GraphTypes || (Models.GraphTypes = {}));
            })(Models = Graph.Models || (Graph.Models = {}));
        })(Graph = Controls.Graph || (Controls.Graph = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=GraphTypes.pre.js.map
